interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <div className="flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          className={`w-9 h-9 rounded-md text-sm font-label transition-colors cursor-pointer ${
            item === page
              ? "bg-primary-500 text-background-50"
              : "border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {item}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}